import React, { useRef,useEffect } from 'react';
import tick from "../img/tick.png";
import cross from "../img/cross.png";
import NavBar from "./NavBar";
import Footer from './Footer';
import emailjs from '@emailjs/browser';

export default function Contattaci(){



    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        
        const nome = document.getElementById("nome");
        const email = document.getElementById("email");
        const testo = document.getElementById("testo");

        if(!controllo()){
            alert("Compilare tutti i campi");
        }else{
            emailjs.sendForm('service_2ntt6ks', 'template_dn1ciak', form.current, 'nqbQvbtd4hNb01scB')
            .then((result) => {
                
                console.log(result.text);
                document.getElementById("inviato").style.display ="block";
                nome.disabled = true;
                email.disabled = true;
                testo.disabled = true;
                document.getElementById("invia").disabled = true;
            }, (error) => {
                console.log(error.text);
                document.getElementById("errore").style.display ="block"
            });
        }
    };
    function tastoCliccato(){
        if(controllo()){
            setTimeout(() => {
                document.getElementById("invia").disabled = true;
            }, "100");
        }
    }
    function controllo(){
        const nome = document.getElementById("nome");
        const email = document.getElementById("email");
        const testo = document.getElementById("testo");
        if(!nome && !email && !testo){
            return false;
        }
        if(nome.value.trim()===""||email.value.trim()==="@"||testo.value.trim()===""||testo.value.trim().length<=0){
            return false;
        }
        return true;
    }
    
    

    return (
        <div className='contattaciBody wuXieKeJi'>
            

            <NavBar uno="Informazioni" due="Prodotti" tre="Catalogo" one="/informazioni" two="/prodotti" three="/catalogo"/>
            <div style={{height:"70vh"}}>
                <div className="centroPagina">
                
                    <h1 style={{color:"black",padding:"30px",fontWeight:"400"}}> Contattaci</h1>
                    <form ref={form} onSubmit={sendEmail} className="form">
                        
                        <input type="text" name="user_name" placeholder="Nome" className="infoCliente" required id="nome"/>
                        
                        <input type="email" name="user_email" placeholder="Email" className="infoCliente" required id="email"/>
                        
                        <textarea name="message" placeholder="Richiesta / Domanda" className="infoCliente" required id="testo"/>
                        <input onClick={()=>tastoCliccato()} type="submit" value="Invia" required id="invia"/>
                    </form>
                    <div className="messaggio" id="inviato" style={{display:"none"}}>
                        <h4 style={{color:"lightGreen"}}>Messaggio inviato con successo</h4>
                        <img src={tick} alt="tick" id="tick"/>
                        <p>Risponderemo il prima possibile alla email da voi fornita.</p>
                    </div>
                    <div className="messaggio" id="errore" style={{display:"none"}}>
                        <h4 style={{color:"red"}}>Errore</h4>
                        <img src={cross} alt="cross" id="cross" />
                        <p>Ci dispiace per l'inconvenienza riprova più tardi.</p>
                    </div>
                    
                </div>
            </div>

            <Footer />

        </div>
    )
}